import { render, staticRenderFns } from "./ServiceCouponDef.vue?vue&type=template&id=5133fb9a&"
import script from "./ServiceCouponDef.vue?vue&type=script&lang=js&"
export * from "./ServiceCouponDef.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCouponDef.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports